import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/views/Login';
import Main from '@/views/Main';
import BaseView from '@/components/main/BaseView';
import Dashboard from '@/views/Dashboard';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Login
  },
  {
    path: "/",
    component: Main,
    beforeEnter(to, from, next) {
      if (store.state.token) {
        next();
      } else {
        next("/");
      }
    },
    children: [
      { 
        path: '/dashboard', 
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      { 
        path: '/usuario_grupo',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-usuario_grupo',
            component: () => import("@/views/usuario_grupo/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-usuario_grupo',
              component: () => import("@/views/usuario_grupo/Form.vue"),
              meta: { requiresAuth: true }
          }
        ]
      },
      { 
        path: '/usuario',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-usuario',
            component: () => import("@/views/usuario/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-usuario',
              component: () => import("@/views/usuario/Form.vue"),
              meta: { requiresAuth: true }
          }
        ]
      },
      { 
        path: '/configuracao',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-configuracao',
            component: () => import("@/views/configuracao/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-configuracao',
              component: () => import("@/views/configuracao/Form.vue"),
              meta: { requiresAuth: true }
          }
        ]
      },
      { 
        path: '/user',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-user',
            component: () => import("@/views/user/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-user',
              component: () => import("@/views/user/Form.vue"),
              meta: { requiresAuth: true }
          },
          {
              path: 'view/:id',
              name: 'view-user',
              component: () => import("@/views/user/View.vue"),
              meta: { requiresAuth: true }
          }
        ]
      },
      { 
        path: '/protective_measure',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-protective_measure',
            component: () => import("@/views/protective_measure/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-protective_measure',
              component: () => import("@/views/protective_measure/Form.vue"),
              meta: { requiresAuth: true }
          },
          {
              path: 'view/:id',
              name: 'view-protective_measure',
              component: () => import("@/views/protective_measure/View.vue"),
              meta: { requiresAuth: true }
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: "active",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    $(".preloader").children().show();
    $(".preloader").css('height', '100%');
  
    setTimeout(function () {  
      $(".preloader").css('height', 0);      
      setTimeout(function () {
        $(".preloader").children().hide();
      }, 200);
    }, 500);
  
    if (store.state.token) {
      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;